import { render, staticRenderFns } from "./PictureBookDelete.vue?vue&type=template&id=1591f31d&"
import script from "./PictureBookDelete.vue?vue&type=script&lang=js&"
export * from "./PictureBookDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports